import API, { config, baseURL } from './_main';
import * as axios from 'axios';
import * as NotificationModule from 'Modules/NotificationModule';

export function getNotifications(params?: URLSearchParams): axios.AxiosPromise<NotificationModule.Types.GetNotificationsResponse> {
    return API.get(`notification`, config(params));
}

export function readNotification(notificationParam?: NotificationModule.Types.INotificationReadParams) {
    return API.patch(`notification`, notificationParam, config());
}

export function openNotificationWSS(token:string): EventSource {
    return new EventSource(`${baseURL}/sse/notification?token=${token}`, { withCredentials: true });
}



// WEBPACK FOOTER //
// ./src/Connectors/NotificationConnector.ts